import { DataSchemaType } from "@/types/dataset";

import { twMerge } from "tailwind-merge";

interface BadgeDataTypeProps {
  type: DataSchemaType;
  className?: string;
}

export default function BadgeDataType({ type, className }: BadgeDataTypeProps) {
  const getTypeStyles = () => {
    switch (type) {
      case DataSchemaType.INT:
        return "bg-blue-50 text-blue-700 border border-blue-200";
      case DataSchemaType.FLOAT:
      case DataSchemaType.LATITUDE:
      case DataSchemaType.LONGITUDE:
      case DataSchemaType.PERCENTAGE:
      case DataSchemaType.RATIO:
        return "bg-green-50 text-green-700 border border-green-200";
      case DataSchemaType.TEXT:
        return "bg-gray-100 text-gray-700 border border-gray-200";
      case DataSchemaType.BOOL:
        return "bg-yellow-50 text-yellow-800 border border-yellow-600";
      case DataSchemaType.DATE_TIME:
        return "bg-red-50 text-red-700 border border-red-200";
      case DataSchemaType.DATE:
        return "bg-orange-50 text-orange-700 border border-orange-200";
      case DataSchemaType.TIME:
        return "bg-pink-50 text-pink-600 border border-pink-200";
      case DataSchemaType.JSON:
        return "bg-blue-50 text-blue-700 border border-blue-200";
      case DataSchemaType.GEOMETRY:
        return "bg-green-50 text-green-700 border border-green-200";
      default:
        return "bg-gray-100 text-gray-500 border border-gray-200";
    }
  };

  const getTitle = () => {
    switch (type) {
      case DataSchemaType.BOOL:
        return "boolean";
      case DataSchemaType.GEOMETRY:
        return "geom";
      default:
        return type;
    }
  };

  return (
    <span
      className={twMerge(
        "inline-flex items-center justify-center px-2 py-0.5 text-xs font-semibold rounded-lg leading-5",
        getTypeStyles(),
        className
      )}
      data-testid={`badge-data-type-${getTitle()}`}
    >
      {getTitle()}
    </span>
  );
}
